import { PropType } from 'vue';
import { Options } from 'vue-class-component';
import { ActionDTO, PlantDetailDTO } from '@/../client-generator/generated-clients/plants';
import SceneTimeObject from '../../SceneTimeObject/SceneTimeObject.vue';
import { BaseSceneSlide, SceneSlideType } from '../SceneSlide.base';

@Options({
  name: 'ActionSceneSlide',
  props: {
    sceneId: {
      type: String,
      required: true,
    },
    actions: {
      type: Array.of(Object as PropType<ActionDTO>),
      required: true,
    },
    plant: {
      type: Object as PropType<PlantDetailDTO>,
    },
  },
  components: {
    SceneTimeObject,
  },
})
export default class ActionSceneSlide extends BaseSceneSlide {
  plant!: PlantDetailDTO;
  sceneId!: string;
  actions: ActionDTO[] = [];
  slideType = SceneSlideType.ACTION;

  mounted() {
    this.items = this.actions;
    this.$nextTick(() => super.inferSlideType());
  }

  unmounted() {
    super.unmounted();
  }
}
